"use client";
import { useScrollReveal } from "@/hooks/common/useScrollReveal";
import { useCounter } from "@/hooks/common/useCounter";
import GcsImage from "@/components/common/GcsImage";
import { whiteShield } from "@/lib/gcsImagePaths";

export default function NumbersSection() {
  const { ref, isVisible } = useScrollReveal();

  const carriersCountResult = useCounter({
    end: 50,
    duration: 2000,
    triggerMode: "manual",
    isVisible,
  });
  const npsCountResult = useCounter({
    end: 88,
    duration: 2000,
    triggerMode: "manual",
    isVisible,
  });
  const yearsCountResult = useCounter({
    end: 17,
    duration: 2000,
    triggerMode: "manual",
    isVisible,
  });
  const experienceCountResult = useCounter({
    end: 450,
    duration: 2000,
    triggerMode: "manual",
    isVisible,
  });

  const carriersCount = carriersCountResult.count;
  const npsCount = npsCountResult.count;
  const yearsCount = yearsCountResult.count;
  const experienceCount = experienceCountResult.count;

  return (
    <section
      ref={ref}
      className="py-16 md:py-24 bg-primary text-primary-foreground"
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
          <div className="text-center">
            <div className="relative inline-block mb-2">
              <GcsImage
                path={whiteShield}
                alt="Shield background"
                className="w-44 h-44 object-contain"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-4xl md:text-5xl font-bold text-[#090739]">
                  {carriersCount}+
                </div>
              </div>
            </div>
            <div className="text-base md:text-lg opacity-90 font-semibold mb-1">
              Top-Rated Carriers
            </div>
            <div className="text-xs md:text-sm opacity-75">
              competing to find your best coverage.
            </div>
          </div>

          <div className="text-center">
            <div className="relative inline-block mb-2">
              <GcsImage
                path={whiteShield}
                alt="Shield background"
                className="w-44 h-44 object-contain"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-4xl md:text-5xl font-bold text-[#090739]">
                  {npsCount}
                </div>
              </div>
            </div>
            <div className="text-base md:text-lg opacity-90 font-semibold mb-1">
              Net Promoter Score
            </div>
            <div className="text-xs md:text-sm opacity-75">
              from thousands of satisfied members.
            </div>
          </div>

          <div className="text-center">
            <div className="relative inline-block mb-2">
              <GcsImage
                path={whiteShield}
                alt="Shield background"
                className="w-44 h-44 object-contain"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-4xl md:text-5xl font-bold text-[#090739]">
                  {yearsCount}+
                </div>
              </div>
            </div>
            <div className="text-base md:text-lg opacity-90 font-semibold mb-1">
              Years in Business
            </div>
            <div className="text-xs md:text-sm opacity-75">
              backed by Three Ships, a proven digital operator.
            </div>
          </div>

          <div className="text-center">
            <div className="relative inline-block mb-2">
              <GcsImage
                path={whiteShield}
                alt="Shield background"
                className="w-44 h-44 object-contain"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-4xl md:text-5xl font-bold text-[#090739]">
                  {experienceCount}+
                </div>
              </div>
            </div>
            <div className="text-base md:text-lg opacity-90 font-semibold mb-1">
              Years Experience
            </div>
            <div className="text-xs md:text-sm opacity-75">
              across our team of insurance experts.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
